// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: "Inter", ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

input:where([type='text']),input:where(:not([type])),input:where([type='email']),input:where([type='url']),input:where([type='password']),input:where([type='number']),input:where([type='date']),input:where([type='datetime-local']),input:where([type='month']),input:where([type='search']),input:where([type='tel']),input:where([type='time']),input:where([type='week']),select:where([multiple]),textarea,select{
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

input:where([type='text']):focus, input:where(:not([type])):focus, input:where([type='email']):focus, input:where([type='url']):focus, input:where([type='password']):focus, input:where([type='number']):focus, input:where([type='date']):focus, input:where([type='datetime-local']):focus, input:where([type='month']):focus, input:where([type='search']):focus, input:where([type='tel']):focus, input:where([type='time']):focus, input:where([type='week']):focus, select:where([multiple]):focus, textarea:focus, select:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder{
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}

::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit{
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}

select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}

select:where([multiple]),select:where([size]:not([size="1"])){
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}

input:where([type='checkbox']),input:where([type='radio']){
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

input:where([type='checkbox']){
  border-radius: 0px;
}

input:where([type='radio']){
  border-radius: 100%;
}

input:where([type='checkbox']):focus,input:where([type='radio']):focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

input:where([type='checkbox']):checked,input:where([type='radio']):checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

input:where([type='checkbox']):checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active) {

  input:where([type='checkbox']):checked{
    appearance: auto;
  }
}

input:where([type='radio']):checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active) {

  input:where([type='radio']):checked{
    appearance: auto;
  }
}

input:where([type='checkbox']):checked:hover,input:where([type='checkbox']):checked:focus,input:where([type='radio']):checked:hover,input:where([type='radio']):checked:focus{
  border-color: transparent;
  background-color: currentColor;
}

input:where([type='checkbox']):indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active) {

  input:where([type='checkbox']):indeterminate{
    appearance: auto;
  }
}

input:where([type='checkbox']):indeterminate:hover,input:where([type='checkbox']):indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}

input:where([type='file']){
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

input:where([type='file']):focus{
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.form-input,.form-textarea,.form-select,.form-multiselect{
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}
.form-input:focus, .form-textarea:focus, .form-select:focus, .form-multiselect:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}
.form-input::placeholder,.form-textarea::placeholder{
  color: #6b7280;
  opacity: 1;
}
.form-input::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}
.form-input::-webkit-date-and-time-value{
  min-height: 1.5em;
  text-align: inherit;
}
.form-input::-webkit-datetime-edit{
  display: inline-flex;
}
.form-input::-webkit-datetime-edit,.form-input::-webkit-datetime-edit-year-field,.form-input::-webkit-datetime-edit-month-field,.form-input::-webkit-datetime-edit-day-field,.form-input::-webkit-datetime-edit-hour-field,.form-input::-webkit-datetime-edit-minute-field,.form-input::-webkit-datetime-edit-second-field,.form-input::-webkit-datetime-edit-millisecond-field,.form-input::-webkit-datetime-edit-meridiem-field{
  padding-top: 0;
  padding-bottom: 0;
}
.form-select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}
.form-select:where([size]:not([size="1"])){
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1\\/4{
  bottom: 25%;
}
.bottom-\\[-15\\%\\]{
  bottom: -15%;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 0.125rem;
}
.left-1\\/2{
  left: 50%;
}
.left-1\\/4{
  left: 25%;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-\\[-8\\%\\]{
  left: -8%;
}
.left-full{
  left: 100%;
}
.right-0{
  right: 0px;
}
.right-1\\/4{
  right: 25%;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-6{
  right: 1.5rem;
}
.right-\\[-8\\%\\]{
  right: -8%;
}
.right-full{
  right: 100%;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1\\/2{
  top: 50%;
}
.top-1\\/4{
  top: 25%;
}
.top-6{
  top: 1.5rem;
}
.top-\\[-15\\%\\]{
  top: -15%;
}
.top-full{
  top: 100%;
}
.-z-0{
  z-index: 0;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-50{
  z-index: 50;
}
.z-\\[10000\\]{
  z-index: 10000;
}
.z-\\[1030\\]{
  z-index: 1030;
}
.z-\\[1050\\]{
  z-index: 1050;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.z-auto{
  z-index: auto;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.m-0{
  margin: 0px;
}
.mx-0\\.5{
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-3\\.5{
  margin-top: 0.875rem;
  margin-bottom: 0.875rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-1{
  margin-bottom: -0.25rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 0.125rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-3\\.5{
  margin-bottom: 0.875rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-0\\.5{
  margin-right: 0.125rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.list-item{
  display: list-item;
}
.hidden{
  display: none;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[170px\\]{
  height: 170px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[42px\\]{
  height: 42px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[60\\%\\]{
  height: 60%;
}
.h-\\[70\\%\\]{
  height: 70%;
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-\\[48px\\]{
  max-height: 48px;
}
.max-h-\\[75vh\\]{
  max-height: 75vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[calc\\(100vh-220px\\)\\]{
  max-height: calc(100vh - 220px);
}
.max-h-\\[calc\\(100vh-280px\\)\\]{
  max-height: calc(100vh - 280px);
}
.max-h-\\[calc\\(100vh-320px\\)\\]{
  max-height: calc(100vh - 320px);
}
.max-h-\\[calc\\(100vh-32px\\)\\]{
  max-height: calc(100vh - 32px);
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[190px\\]{
  min-height: 190px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[240px\\]{
  min-height: 240px;
}
.min-h-\\[260px\\]{
  min-height: 260px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[48px\\]{
  min-height: 48px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-auto{
  width: auto !important;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-40{
  width: 10rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[170px\\]{
  width: 170px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[1100px\\]{
  min-width: 1100px;
}
.min-w-\\[110px\\]{
  min-width: 110px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[130px\\]{
  min-width: 130px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[240px\\]{
  min-width: 240px;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-\\[290px\\]{
  min-width: 290px;
}
.min-w-\\[32px\\]{
  min-width: 32px;
}
.min-w-\\[48px\\]{
  min-width: 48px;
}
.min-w-\\[620px\\]{
  min-width: 620px;
}
.min-w-\\[650px\\]{
  min-width: 650px;
}
.min-w-\\[760px\\]{
  min-width: 760px;
}
.min-w-\\[800px\\]{
  min-width: 800px;
}
.min-w-\\[840px\\]{
  min-width: 840px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1600px\\]{
  max-width: 1600px;
}
.max-w-\\[160px\\]{
  max-width: 160px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[240px\\]{
  max-width: 240px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[320px\\]{
  max-width: 320px;
}
.max-w-\\[340px\\]{
  max-width: 340px;
}
.max-w-\\[360px\\]{
  max-width: 360px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[440px\\]{
  max-width: 440px;
}
.max-w-\\[480px\\]{
  max-width: 480px;
}
.max-w-\\[48px\\]{
  max-width: 48px;
}
.max-w-\\[72px\\]{
  max-width: 72px;
}
.max-w-\\[calc\\(100vw-2rem\\)\\]{
  max-width: calc(100vw - 2rem);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.border-collapse{
  border-collapse: collapse;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[80px_1fr_1fr\\]{
  grid-template-columns: 80px 1fr 1fr;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-rose-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-divide-opacity, 1));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.divide-slate-800\\/60 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(30 41 59 / 0.6);
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[2rem\\]{
  border-radius: 2rem;
}
.rounded-\\[calc\\(var\\(--radius-md\\)-2px\\)\\]{
  border-radius: calc(var(--radius-md) - 2px);
}
.rounded-\\[var\\(--radius-md\\)\\]{
  border-radius: var(--radius-md);
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-3xl{
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}
.rounded-l{
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-r{
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-solid{
  border-style: solid;
}
.border-\\[\\#176B5B\\]\\/20{
  border-color: rgb(23 107 91 / 0.2);
}
.border-\\[var\\(--border\\)\\]{
  border-color: var(--border);
}
.border-\\[var\\(--border-strong\\)\\]{
  border-color: var(--border-strong);
}
.border-\\[var\\(--border-subtle\\)\\]{
  border-color: var(--border-subtle);
}
.border-\\[var\\(--danger\\)\\]{
  border-color: var(--danger);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/20{
  border-color: rgb(245 158 11 / 0.2);
}
.border-black\\/10{
  border-color: rgb(0 0 0 / 0.1);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/60{
  border-color: rgb(167 243 208 / 0.6);
}
.border-emerald-500{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/20{
  border-color: rgb(16 185 129 / 0.2);
}
.border-emerald-500\\/30{
  border-color: rgb(16 185 129 / 0.3);
}
.border-emerald-500\\/60{
  border-color: rgb(16 185 129 / 0.6);
}
.border-emerald-600{
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.border-emerald-600\\/50{
  border-color: rgb(5 150 105 / 0.5);
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/20{
  border-color: rgb(99 102 241 / 0.2);
}
.border-indigo-500\\/30{
  border-color: rgb(99 102 241 / 0.3);
}
.border-indigo-700\\/60{
  border-color: rgb(67 56 202 / 0.6);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-200\\/60{
  border-color: rgb(254 205 211 / 0.6);
}
.border-rose-200\\/70{
  border-color: rgb(254 205 211 / 0.7);
}
.border-rose-200\\/90{
  border-color: rgb(254 205 211 / 0.9);
}
.border-rose-300\\/80{
  border-color: rgb(253 164 175 / 0.8);
}
.border-rose-500{
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.border-rose-500\\/20{
  border-color: rgb(244 63 94 / 0.2);
}
.border-rose-500\\/30{
  border-color: rgb(244 63 94 / 0.3);
}
.border-rose-900\\/60{
  border-color: rgb(136 19 55 / 0.6);
}
.border-sky-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/60{
  border-color: rgb(226 232 240 / 0.6);
}
.border-slate-200\\/80{
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-200\\/90{
  border-color: rgb(226 232 240 / 0.9);
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-600\\/60{
  border-color: rgb(71 85 105 / 0.6);
}
.border-slate-700{
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-slate-700\\/60{
  border-color: rgb(51 65 85 / 0.6);
}
.border-slate-800{
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-slate-800\\/80{
  border-color: rgb(30 41 59 / 0.8);
}
.border-teal-200{
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#070D1E\\]\\/80{
  background-color: rgb(7 13 30 / 0.8);
}
.bg-\\[\\#070D1E\\]\\/90{
  background-color: rgb(7 13 30 / 0.9);
}
.bg-\\[\\#093528\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(9 53 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0A2E23\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 46 35 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B132B\\]\\/95{
  background-color: rgb(11 19 43 / 0.95);
}
.bg-\\[\\#0E172E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(14 23 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#10B981\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1C1F4A\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 31 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3B82F6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8F6820\\]\\/15{
  background-color: rgb(143 104 32 / 0.15);
}
.bg-\\[\\#C9A76A\\]\\/20{
  background-color: rgb(201 167 106 / 0.2);
}
.bg-\\[\\#EF4444\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F59E0B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-\\[var\\(--accent\\)\\]{
  background-color: var(--accent);
}
.bg-\\[var\\(--accent-soft\\)\\]{
  background-color: var(--accent-soft);
}
.bg-\\[var\\(--bg\\)\\]{
  background-color: var(--bg);
}
.bg-\\[var\\(--border\\)\\]{
  background-color: var(--border);
}
.bg-\\[var\\(--danger\\)\\]{
  background-color: var(--danger);
}
.bg-\\[var\\(--danger-soft\\)\\]{
  background-color: var(--danger-soft);
}
.bg-\\[var\\(--info-soft\\)\\]{
  background-color: var(--info-soft);
}
.bg-\\[var\\(--success\\)\\]{
  background-color: var(--success);
}
.bg-\\[var\\(--success-soft\\)\\]{
  background-color: var(--success-soft);
}
.bg-\\[var\\(--surface\\)\\]{
  background-color: var(--surface);
}
.bg-\\[var\\(--surface-2\\)\\]{
  background-color: var(--surface-2);
}
.bg-\\[var\\(--warning-soft\\)\\]{
  background-color: var(--warning-soft);
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-100\\/80{
  background-color: rgb(254 243 199 / 0.8);
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/10{
  background-color: rgb(245 158 11 / 0.1);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-current{
  background-color: currentColor;
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100\\/80{
  background-color: rgb(209 250 229 / 0.8);
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10{
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/15{
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/20{
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-950{
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100\\/80{
  background-color: rgb(224 231 255 / 0.8);
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/10{
  background-color: rgb(99 102 241 / 0.1);
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-indigo-950{
  --tw-bg-opacity: 1;
  background-color: rgb(30 27 75 / var(--tw-bg-opacity, 1));
}
.bg-purple-100\\/80{
  background-color: rgb(243 232 255 / 0.8);
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-200\\/80{
  background-color: rgb(254 205 211 / 0.8);
}
.bg-rose-200\\/90{
  background-color: rgb(254 205 211 / 0.9);
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/20{
  background-color: rgb(255 241 242 / 0.2);
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-500\\/10{
  background-color: rgb(244 63 94 / 0.1);
}
.bg-rose-500\\/20{
  background-color: rgb(244 63 94 / 0.2);
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-200\\/70{
  background-color: rgb(226 232 240 / 0.7);
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/40{
  background-color: rgb(248 250 252 / 0.4);
}
.bg-slate-50\\/50{
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/70{
  background-color: rgb(248 250 252 / 0.7);
}
.bg-slate-50\\/80{
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-800{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/50{
  background-color: rgb(30 41 59 / 0.5);
}
.bg-slate-800\\/80{
  background-color: rgb(30 41 59 / 0.8);
}
.bg-slate-900{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/60{
  background-color: rgb(15 23 42 / 0.6);
}
.bg-slate-950\\/70{
  background-color: rgb(2 6 23 / 0.7);
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/\\[0\\.03\\]{
  background-color: rgb(255 255 255 / 0.03);
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#141414\\]{
  --tw-gradient-from: #141414 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 20 20 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#176B5B\\]{
  --tw-gradient-from: #176B5B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(23 107 91 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#C9A76A\\]{
  --tw-gradient-from: #C9A76A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(201 167 106 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-600{
  --tw-gradient-from: #059669 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 150 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#101011\\]{
  --tw-gradient-to: rgb(16 16 17 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #101011 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#125447\\]{
  --tw-gradient-to: rgb(18 84 71 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #125447 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#E2D9C8\\]{
  --tw-gradient-to: rgb(226 217 200 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E2D9C8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#0A2E26\\]{
  --tw-gradient-to: #0A2E26 var(--tw-gradient-to-position);
}
.to-\\[\\#0B0B0C\\]{
  --tw-gradient-to: #0B0B0C var(--tw-gradient-to-position);
}
.to-\\[\\#125447\\]{
  --tw-gradient-to: #125447 var(--tw-gradient-to-position);
}
.to-\\[\\#F3EEE6\\]{
  --tw-gradient-to: #F3EEE6 var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.bg-clip-text{
  background-clip: text;
}
.fill-\\[var\\(--warning\\)\\]{
  fill: var(--warning);
}
.fill-current{
  fill: currentColor;
}
.stroke-current{
  stroke: currentColor;
}
.stroke-\\[3\\]{
  stroke-width: 3;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pl-0\\.5{
  padding-left: 0.125rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-7{
  padding-right: 1.75rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-headline{
  font-family: "Inter", ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.font-mono{
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans{
  font-family: "Inter", ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5{
  line-height: 1.25rem;
}
.leading-\\[1\\.08\\]{
  line-height: 1.08;
}
.leading-\\[1\\.12\\]{
  line-height: 1.12;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#14110B\\]{
  --tw-text-opacity: 1;
  color: rgb(20 17 11 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8C877F\\]{
  --tw-text-opacity: 1;
  color: rgb(140 135 127 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C9A76A\\]{
  --tw-text-opacity: 1;
  color: rgb(201 167 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F3EEE6\\]{
  --tw-text-opacity: 1;
  color: rgb(243 238 230 / var(--tw-text-opacity, 1));
}
.text-\\[var\\(--accent\\)\\]{
  color: var(--accent);
}
.text-\\[var\\(--danger\\)\\]{
  color: var(--danger);
}
.text-\\[var\\(--info\\)\\]{
  color: var(--info);
}
.text-\\[var\\(--on-accent\\)\\]{
  color: var(--on-accent);
}
.text-\\[var\\(--status-danger\\)\\]{
  color: var(--status-danger);
}
.text-\\[var\\(--status-info\\)\\]{
  color: var(--status-info);
}
.text-\\[var\\(--status-success\\)\\]{
  color: var(--status-success);
}
.text-\\[var\\(--status-warning\\)\\]{
  color: var(--status-warning);
}
.text-\\[var\\(--success\\)\\]{
  color: var(--success);
}
.text-\\[var\\(--text\\)\\]{
  color: var(--text);
}
.text-\\[var\\(--text-faint\\)\\]{
  color: var(--text-faint);
}
.text-\\[var\\(--text-muted\\)\\]{
  color: var(--text-muted);
}
.text-\\[var\\(--warning\\)\\]{
  color: var(--warning);
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-current{
  color: currentColor;
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-indigo-300{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-primary{
  color: var(--accent);
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-rose-400{
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-600\\/80{
  color: rgb(225 29 72 / 0.8);
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-slate-100{
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-200{
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300{
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-400\\/90{
  color: rgb(148 163 184 / 0.9);
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.no-underline{
  text-decoration-line: none;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-slate-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[var\\(--accent\\)\\]{
  accent-color: var(--accent);
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-45{
  opacity: 0.45;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-85{
  opacity: 0.85;
}
.mix-blend-screen{
  mix-blend-mode: screen;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-4px_10px_-2px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 -4px 10px -2px rgb(0,0,0,0.08);
  --tw-shadow-colored: 0 -4px 10px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 20px 50px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card{
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03), 0 1px 2px -1px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card{
  --tw-shadow-color: var(--surface);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-400\\/80{
  --tw-shadow-color: rgb(52 211 153 / 0.8);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-600\\/20{
  --tw-shadow-color: rgb(5 150 105 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-emerald-600\\/30{
  --tw-shadow-color: rgb(5 150 105 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-rose-600\\/30{
  --tw-shadow-color: rgb(225 29 72 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[var\\(--danger-soft\\)\\]{
  --tw-ring-color: var(--danger-soft);
}
.ring-emerald-500\\/20{
  --tw-ring-color: rgb(16 185 129 / 0.2);
}
.ring-emerald-500\\/50{
  --tw-ring-color: rgb(16 185 129 / 0.5);
}
.ring-rose-500\\/20{
  --tw-ring-color: rgb(244 63 94 / 0.2);
}
.ring-rose-500\\/50{
  --tw-ring-color: rgb(244 63 94 / 0.5);
}
.ring-teal-500\\/50{
  --tw-ring-color: rgb(20 184 166 / 0.5);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[110px\\]{
  --tw-blur: blur(110px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[90px\\]{
  --tw-blur: blur(90px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* ============================================================
   SILENCE & GOLD DESIGN TOKENS (LIGHT & DARK MODES)
   ============================================================ */

:root,
[data-theme="light"] {
    /* Typography System Tokens (ONE Font Family Everywhere) */
    --font-sans:              'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    --font-mono:              'JetBrains Mono', monospace;

    --text-xs:                0.75rem;     /* 12px - labels, micro-copy, badges */
    --text-sm:                0.875rem;    /* 14px - body, buttons, inputs */
    --text-base:              1rem;        /* 16px - section titles, subheadings */
    --text-lg:                1.125rem;    /* 18px - card titles, large labels */
    --text-xl:                1.5rem;      /* 24px - page titles */
    --text-kpi:               clamp(1.75rem, 2.5vw, 2rem); /* 28-32px - KPI metrics */
    --text-2xl:               2rem;        /* 32px - marketing section titles */
    --text-3xl:               clamp(2.5rem, 5vw, 3rem); /* 40-48px - landing hero headline */

    --line-height-body:       1.4;
    --line-height-heading:    1.2;

    /* Canonical Tokens - Clean SaaS Light Palette */
    --bg:                 #F8FAFC;
    --surface:            #FFFFFF;
    --surface-2:          #F1F5F9;
    --border:             #E2E8F0;
    --text:               #0F172A;
    --text-muted:         #64748B;
    --text-faint:         #94A3B8;
    --accent:             #4F46E5;
    --accent-hover:       #4338CA;
    --accent-soft:        #EEF2FF;
    --on-accent:          #FFFFFF;

    /* Status Tokens */
    --success:            #16A34A;
    --success-soft:       #DCFCE7;
    --warning:            #D97706;
    --warning-soft:       #FEF3C7;
    --danger:             #DC2626;
    --danger-soft:        #FEE2E2;
    --info:               #0284C7;
    --info-soft:          #E0F2FE;

    /* Border & Radius System Tokens */
    --radius-lg:              12px;
    --radius-md:              8px;
    --radius-pill:            999px;

    --border-gradient-start:  rgba(79, 70, 229, 0.35);
    --border-gradient-end:    #E2E8F0;
    --border-subtle:          #E2E8F0;
    --border-strong:          #CBD5E1;
    --border-active:          var(--accent);
    --glow-hover:             0 0 0 1px var(--accent-soft), 0 4px 12px rgba(79, 70, 229, 0.08);
    --edge-highlight:         inset 0 1px 0 rgba(255, 255, 255, 0.9);

    /* Mapped Compatibility Variables */
    --color-bg:               var(--bg);
    --color-surface:          var(--surface);
    --color-surface-secondary:var(--surface-2);
    --color-card:             var(--surface);
    --color-card-hover:       var(--surface-2);
    --color-sidebar:          var(--surface);
    --color-header:           var(--surface);
    --color-control:          var(--surface-2);
    --color-text:             var(--text);
    --color-heading:          var(--text);
    --color-text-secondary:   var(--text-muted);
    --color-subtext:          var(--text-muted);
    --color-text-muted:       var(--text-faint);
    --color-border:           var(--border);
    --color-border-subtle:    var(--border-subtle);
    --color-border-solid:     var(--border);
    --color-divider:          var(--border);

    --color-primary:          var(--accent);
    --color-primary-hover:    var(--accent-hover);
    --color-primary-light:    var(--accent-soft);
    --color-primary-dark:     var(--accent-hover);
    --color-primary-mid:      var(--accent);

    --color-badge:            var(--accent-soft);
    --color-badge-text:       var(--accent);

    --color-input-bg:         var(--surface);
    --color-input-border:     var(--border);
    --color-input-focus:      var(--accent);
    --color-input-placeholder:var(--text-faint);

    --color-table-header-bg:  var(--surface-2);
    --color-table-header-text:var(--text-muted);
    --color-table-row-hover:  var(--surface-2);
    --color-table-border:     var(--border);

    --color-overlay:          rgba(23, 21, 15, 0.45);
    --color-tooltip-bg:       var(--surface-2);
    --color-tooltip-text:     var(--text);

    --color-success:          var(--success);
    --color-success-light:    var(--success-soft);
    --color-warning:          var(--warning);
    --color-warning-light:    var(--warning-soft);
    --color-error:            var(--danger);
    --color-error-light:      var(--danger-soft);
    --color-info:             var(--info);
    --color-info-light:       var(--info-soft);

    --shadow-soft-sm:         0 1px 3px rgba(23, 21, 15, 0.05);
    --shadow-card:            0 1px 3px rgba(23, 21, 15, 0.04), 0 1px 2px -1px rgba(23, 21, 15, 0.03);
}

.dark,
[data-theme="dark"] {
    /* Typography System Tokens (ONE Font Family Everywhere) */
    --font-sans:              'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    --font-mono:              'JetBrains Mono', monospace;

    --text-xs:                0.75rem;     /* 12px - labels, micro-copy, badges */
    --text-sm:                0.875rem;    /* 14px - body, buttons, inputs */
    --text-base:              1rem;        /* 16px - section titles, subheadings */
    --text-lg:                1.125rem;    /* 18px - card titles, large labels */
    --text-xl:                1.5rem;      /* 24px - page titles */
    --text-kpi:               clamp(1.75rem, 2.5vw, 2rem); /* 28-32px - KPI metrics */
    --text-2xl:               2rem;        /* 32px - marketing section titles */
    --text-3xl:               clamp(2.5rem, 5vw, 3rem); /* 40-48px - landing hero headline */

    --line-height-body:       1.4;
    --line-height-heading:    1.2;

    /* Canonical Tokens - Clean SaaS Dark Palette */
    --bg:                 #0B1120;
    --surface:            #111827;
    --surface-2:          #1E293B;
    --border:             #1F2937;
    --text:               #F1F5F9;
    --text-muted:         #94A3B8;
    --text-faint:         #64748B;
    --accent:             #6366F1;
    --accent-hover:       #818CF8;
    --accent-soft:        #1E1B4B;
    --on-accent:          #FFFFFF;

    /* Status Tokens */
    --success:            #22C55E;
    --success-soft:       rgba(34, 197, 94, 0.16);
    --warning:            #F59E0B;
    --warning-soft:       rgba(245, 158, 11, 0.16);
    --danger:             #EF4444;
    --danger-soft:        rgba(239, 68, 68, 0.16);
    --info:               #38BDF8;
    --info-soft:          rgba(56, 189, 248, 0.16);

    /* Border & Radius System Tokens */
    --radius-lg:              12px;
    --radius-md:              8px;
    --radius-pill:            999px;

    --border-gradient-start:  rgba(99, 102, 241, 0.35);
    --border-gradient-end:    #1F2937;
    --border-subtle:          #1F2937;
    --border-strong:          #374151;
    --border-active:          var(--accent);
    --glow-hover:             0 0 0 1px var(--accent-soft), 0 4px 12px rgba(99, 102, 241, 0.12);
    --edge-highlight:         inset 0 1px 0 rgba(255, 255, 255, 0.05);

    /* Mapped Compatibility Variables */
    --color-bg:               var(--bg);
    --color-surface:          var(--surface);
    --color-surface-secondary:var(--surface-2);
    --color-card:             var(--surface);
    --color-card-hover:       var(--surface-2);
    --color-sidebar:          var(--surface);
    --color-header:           var(--surface);
    --color-control:          var(--surface-2);
    --color-text:             var(--text);
    --color-heading:          var(--text);
    --color-text-secondary:   var(--text-muted);
    --color-subtext:          var(--text-muted);
    --color-text-muted:       var(--text-faint);
    --color-border:           var(--border);
    --color-border-subtle:    var(--border-subtle);
    --color-border-solid:     var(--border);
    --color-divider:          var(--border);

    --color-primary:          var(--accent);
    --color-primary-hover:    var(--accent-hover);
    --color-primary-light:    var(--accent-soft);
    --color-primary-dark:     var(--accent-hover);
    --color-primary-mid:      var(--accent);

    --color-badge:            var(--accent-soft);
    --color-badge-text:       var(--accent);

    --color-input-bg:         var(--surface-2);
    --color-input-border:     var(--border);
    --color-input-focus:      var(--accent);
    --color-input-placeholder:var(--text-faint);

    --color-table-header-bg:  var(--surface-2);
    --color-table-header-text:var(--text-muted);
    --color-table-row-hover:  var(--surface-2);
    --color-table-border:     var(--border);

    --color-overlay:          rgba(11, 11, 12, 0.85);
    --color-tooltip-bg:       var(--surface-2);
    --color-tooltip-text:     var(--text);

    --color-success:          var(--success);
    --color-success-light:    var(--success-soft);
    --color-warning:          var(--warning);
    --color-warning-light:    var(--warning-soft);
    --color-error:            var(--danger);
    --color-error-light:      var(--danger-soft);
    --color-info:             var(--info);
    --color-info-light:       var(--info-soft);

    --shadow-soft-sm:         none;
    --shadow-card:            none;
}

/* ============================================================
   REUSABLE PREMIUM BORDER SYSTEM (TASK A)
   ============================================================ */

/**
 * .card-border
 * Dual-layer background gradient hairline border with glass edge highlight.
 * High performance, zero layout shift, seamless rounded corners.
 */
.card-border {
    position: relative;
    border-radius: var(--radius-lg);
    background-color: var(--surface);
    background-image: 
        linear-gradient(var(--surface), var(--surface)), 
        linear-gradient(135deg, var(--border-gradient-start) 0%, var(--border-gradient-end) 100%);
    background-origin: padding-box, border-box;
    background-clip: padding-box, border-box;
    border: 1px solid transparent;
    box-shadow: var(--edge-highlight);
    transition: box-shadow 180ms cubic-bezier(0.4, 0, 0.2, 1),
                border-color 180ms cubic-bezier(0.4, 0, 0.2, 1),
                transform 180ms cubic-bezier(0.4, 0, 0.2, 1),
                background-color 180ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* Interactive Card Variant */
.card-border-interactive {
    cursor: pointer;
}
.card-border-interactive:hover {
    box-shadow: var(--edge-highlight), var(--glow-hover);
    transform: translateY(-1.5px);
}

/* Active / Selected Card State */
.card-border-active,
.card-border.is-active {
    border-color: var(--border-active) !important;
    background-image: none !important;
    background-color: var(--surface) !important;
    box-shadow: var(--edge-highlight), 0 0 0 1px var(--accent-soft), var(--glow-hover) !important;
}

/* Subtle Card Variant (for nested frames, inputs, toolbars) */
.card-border-subtle {
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    background-color: var(--surface-2);
    box-shadow: var(--edge-highlight);
    transition: border-color 180ms ease, box-shadow 180ms ease;
}
.card-border-subtle:focus-within {
    border-color: var(--border-active);
    box-shadow: 0 0 0 2px var(--accent-soft);
}

/* Tiny Gold Corner Accent (Strictly for KPI cards) */
.kpi-corner-accent {
    position: relative;
    overflow: hidden;
}
.kpi-corner-accent::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    border-top: 2px solid var(--accent);
    border-right: 2px solid var(--accent);
    border-top-right-radius: var(--radius-lg);
    opacity: 0.85;
    pointer-events: none;
    transition: opacity 180ms ease, width 180ms ease, height 180ms ease;
}
.kpi-corner-accent:hover::after {
    opacity: 1;
    width: 18px;
    height: 18px;
}

/* Strict 3 columns x 2 rows KPI Grid */
.kpi-3x2-grid {
    display: grid !important;
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    gap: 1.25rem !important;
}

@media (max-width: 768px) {
    .kpi-3x2-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
        gap: 1rem !important;
    }
}

@media (max-width: 480px) {
    .kpi-3x2-grid {
        grid-template-columns: 1fr !important;
    }
}

/* Fading Gradient Divider */
.divider-gradient {
    height: 1px;
    width: 100%;
    background: linear-gradient(90deg, transparent 0%, var(--border) 50%, transparent 100%);
    border: none;
    margin: 0;
    flex-shrink: 0;
}

/* ============================================================
   GLOBAL TYPOGRAPHY, THEME TRANSITIONS & BASE RESETS
   ============================================================ */

html {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: var(--text);
    background-color: var(--bg);
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transition: background-color 180ms ease, color 180ms ease;
}

body {
    color: var(--text);
    background-color: var(--bg);
    margin: 0;
    padding: 0;
}

/* Smooth theme transitions on core surface elements */
body,
.ddwoms-main,
.ddwoms-sidebar,
.ddwoms-sidebar-header,
.ddwoms-sidebar-footer,
nav,
footer,
.card,
table {
    transition: background-color 180ms ease, color 180ms ease, border-color 180ms ease;
}

@media (prefers-reduced-motion: reduce) {
    html, body, *, *::before, *::after {
        transition-duration: 0.01ms !important;
        animation-duration: 0.01ms !important;
    }
}

/* Native selection highlight */
::selection {
    background-color: var(--accent-soft);
    color: var(--accent);
}

/* Keyboard focus rings */
:focus-visible {
    outline: 2px solid var(--accent) !important;
    outline-offset: 2px;
}

/* Native checkbox and radio color */
input[type="checkbox"],
input[type="radio"] {
    accent-color: var(--accent);
}

h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-sans);
    line-height: var(--line-height-heading);
    letter-spacing: -0.02em;
    color: var(--text);
}

.tabular-nums {
    font-variant-numeric: tabular-nums;
}

.font-mono,
code,
pre,
.label-caps {
    font-family: var(--font-mono);
}

/* ============================================================
   TOASTIFY DESIGN SYSTEM INTEGRATION
   ============================================================ */

.Toastify__toast {
    font-family: var(--font-sans) !important;
    background-color: var(--surface) !important;
    color: var(--text) !important;
    border-radius: var(--radius-lg) !important;
    border: 1px solid var(--border-subtle) !important;
    box-shadow: var(--edge-highlight), 0 10px 25px -5px rgba(0, 0, 0, 0.25) !important;
}
.Toastify__toast--success {
    border-color: var(--status-success) !important;
}
.Toastify__toast--error {
    border-color: var(--status-danger) !important;
}
.Toastify__toast--warning {
    border-color: var(--status-warning) !important;
}
.Toastify__progress-bar {
    background: var(--accent) !important;
}
.Toastify__close-button {
    color: var(--text-muted) !important;
}

/* Modern Minimal Scrollbar */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
::-webkit-scrollbar-track {
    background: transparent;
}
::-webkit-scrollbar-thumb {
    background: var(--border);
    border-radius: 9999px;
}
::-webkit-scrollbar-thumb:hover {
    background: var(--text-faint);
}

/* Disabled button state */
button:disabled {
    opacity: 0.45 !important;
    cursor: not-allowed !important;
}

/* ============================================================
   MICRO-ANIMATIONS & UTILITIES
   ============================================================ */

@keyframes stitch-shimmer {
    0%   { background-position: -400px 0; }
    100% { background-position: 400px 0; }
}

@keyframes stitch-fade-in {
    from { opacity: 0; transform: translateY(4px); }
    to   { opacity: 1; transform: translateY(0); }
}

@keyframes stitch-slide-up {
    from { opacity: 0; transform: translateY(12px) scale(0.99); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes stitch-pulse-dot {
    0%, 100% { opacity: 1; transform: scale(1); }
    50%      { opacity: 0.4; transform: scale(0.9); }
}

.stitch-shimmer {
    background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.06) 50%, transparent 100%);
    background-size: 800px 100%;
    animation: stitch-shimmer 1.5s ease-in-out infinite;
}

.stitch-fade-in {
    animation: stitch-fade-in 0.25s ease-out both;
}

.stitch-slide-up {
    animation: stitch-slide-up 0.25s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.stitch-pulse-dot {
    animation: stitch-pulse-dot 2s ease-in-out infinite;
}

/* ============================================================
   MODERN HIGH-DENSITY DATA TABLE STYLES
   ============================================================ */

table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.875rem;
}

th {
    padding: 10px 14px !important;
    font-family: 'Hanken Grotesk', 'Inter', sans-serif !important;
    font-size: 0.75rem !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    color: var(--color-subtext) !important;
    background-color: var(--color-control, #F1F5F9) !important;
    border-bottom: 1px solid var(--color-border) !important;
    white-space: nowrap !important;
    -webkit-user-select: none;
            user-select: none;
}

td {
    padding: 12px 14px !important;
    font-size: 0.875rem !important;
    color: var(--color-text) !important;
    border-bottom: 1px solid var(--color-border) !important;
    transition: background-color 0.15s ease;
}

tbody tr:hover td {
    background-color: var(--surface-2) !important;
}

/* ============================================================
   MODERN FORM CONTROLS & FIELDSETS
   ============================================================ */

.form-control,
input[type="text"]:not(.has-icon-left):not([class*="pl-"]),
input[type="email"]:not(.has-icon-left):not([class*="pl-"]),
input[type="password"]:not(.has-icon-left):not([class*="pl-"]),
input[type="number"]:not(.has-icon-left):not([class*="pl-"]),
input[type="search"]:not(.has-icon-left):not([class*="pl-"]),
select,
textarea {
    width: 100%;
    height: 40px;
    padding: 0 14px;
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--text);
    background-color: var(--surface-2);
    border: 1px solid var(--border-strong);
    border-radius: var(--radius-md);
    outline: none;
    box-shadow: var(--edge-highlight);
    transition: border-color 180ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 180ms cubic-bezier(0.4, 0, 0.2, 1), background-color 180ms ease;
}

.has-icon-left {
    padding-left: 2.5rem !important; /* 40px clear margin for icons */
}

textarea {
    height: auto;
    padding: 10px 14px;
}

input:focus,
select:focus,
textarea:focus {
    background-color: var(--surface) !important;
    border-color: var(--border-active) !important;
    box-shadow: 0 0 0 1px var(--border-active), 0 0 0 3px var(--accent-soft) !important;
}

fieldset {
    border: 1px solid var(--border-subtle) !important;
    border-radius: var(--radius-lg) !important;
    padding: 16px 20px !important;
    margin-bottom: 16px !important;
    background-color: transparent !important;
}

legend {
    width: auto !important;
    padding: 0 8px !important;
    font-family: 'Hanken Grotesk', 'Inter', sans-serif !important;
    font-size: 0.95rem !important;
    font-weight: 700 !important;
    color: var(--accent) !important;
    margin-bottom: 0 !important;
}

/* ============================================================
   CARD, BADGE & UI COMPONENT ENHANCEMENTS
   ============================================================ */

.card {
    position: relative;
    border-radius: var(--radius-lg) !important;
    background-color: var(--surface) !important;
    background-image: 
        linear-gradient(var(--surface), var(--surface)), 
        linear-gradient(135deg, var(--border-gradient-start) 0%, var(--border-gradient-end) 100%) !important;
    background-origin: padding-box, border-box !important;
    background-clip: padding-box, border-box !important;
    border: 1px solid transparent !important;
    box-shadow: var(--edge-highlight) !important;
}

.card-header {
    background-color: transparent !important;
    border-bottom: 1px solid var(--border-subtle) !important;
    padding: 14px 18px !important;
}

/* NProgress minimal sleek bar */
#nprogress .bar {
    background: var(--accent) !important;
    height: 2.5px !important;
    z-index: 10319 !important;
}
#nprogress .spinner {
    top: 16px !important;
    right: 16px !important;
    z-index: 10316 !important;
}
#nprogress .spinner-icon {
    border-top-color: var(--accent) !important;
    border-left-color: var(--accent) !important;
}

/* React Loading Skeleton */
.react-loading-skeleton {
    --base-color: var(--surface-2) !important;
    --highlight-color: var(--border) !important;
}

.dark .react-loading-skeleton,
[data-theme="dark"] .react-loading-skeleton {
    --base-color: var(--surface-2) !important;
    --highlight-color: var(--border) !important;
}

/* Breadcrumb styling */
.breadcrumb-item {
    font-size: 0.85rem !important;
    font-weight: 500 !important;
    color: var(--text-muted) !important;
}
.breadcrumb-item.active {
    color: var(--accent) !important;
    font-weight: 600 !important;
}

/* ── Global Seamless & Nested Input Resets (Prevent Double Borders & Rings) ── */
input[type="text"].bg-transparent,
input[type="email"].bg-transparent,
input[type="password"].bg-transparent,
input[type="number"].bg-transparent,
input[type="search"].bg-transparent,
input.input-seamless,
.auth-input {
    background-color: transparent !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    -webkit-appearance: none;
    padding: 0 !important;
    height: 100% !important;
    min-height: auto !important;
    border-radius: 0 !important;
}

/* ── Dedicated High-Contrast Auth Input Style ── */
.auth-input-field {
    color: var(--text) !important;
    background-color: transparent !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    width: 100% !important;
    font-size: 0.875rem !important;
    font-weight: 600 !important;
}

.auth-input-field::placeholder {
    color: var(--text-faint) !important;
    opacity: 1 !important;
    font-weight: 400 !important;
}

input[type="text"].bg-transparent:focus,
input[type="email"].bg-transparent:focus,
input[type="password"].bg-transparent:focus,
input[type="number"].bg-transparent:focus,
input[type="search"].bg-transparent:focus,
input.input-seamless:focus,
.auth-input:focus,
.search-wrapper input:focus {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
    background-color: transparent !important;
}

/* ── WebKit / Chrome Autofill Normalization ── */
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px var(--surface-2) inset !important;
    -webkit-text-fill-color: var(--text) !important;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
}

/* ── Toast Notifications ── */
.Toastify__toast {
    background-color: var(--surface) !important;
    color: var(--text) !important;
    border: 1px solid var(--border) !important;
    border-radius: 12px !important;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25) !important;
}
.Toastify__toast-body {
    color: var(--text) !important;
}
.Toastify__close-button {
    color: var(--text-muted) !important;
}
.Toastify__progress-bar--success { background: var(--success) !important; }
.Toastify__progress-bar--warning { background: var(--warning) !important; }
.Toastify__progress-bar--error   { background: var(--danger)  !important; }
.Toastify__progress-bar--info    { background: var(--info)    !important; }

/* ── Modal Animation Utilities ── */
@keyframes stitchSlideUp {
    from {
        opacity: 0;
        transform: translateY(12px) scale(0.985);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}
@keyframes stitchFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}
.stitch-slide-up {
    animation: stitchSlideUp 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.stitch-fade-in {
    animation: stitchFadeIn 0.18s ease-out forwards;
}

/* ============================================================
   UNIVERSAL THEME SURFACES & KPI GRID (ROBUST DARK & LIGHT MODES)
   ============================================================ */

.card-surface,
.bg-card-surface {
    background-color: var(--surface) !important;
    color: var(--text) !important;
    border-color: var(--border) !important;
}

.card-surface-2,
.bg-card-surface-2 {
    background-color: var(--surface-2) !important;
    color: var(--text) !important;
    border-color: var(--border) !important;
}

/* Direct dark mode overrides for any hardcoded classes */
.dark .card-surface,
.dark .bg-white,
[data-theme="dark"] .card-surface,
[data-theme="dark"] .bg-white {
    background-color: var(--surface) !important;
    color: var(--text) !important;
    border-color: var(--border) !important;
}

.dark .bg-slate-50,
[data-theme="dark"] .bg-slate-50,
.dark .bg-slate-100,
[data-theme="dark"] .bg-slate-100 {
    background-color: var(--surface-2) !important;
    color: var(--text) !important;
    border-color: var(--border) !important;
}

.dark text,
[data-theme="dark"] text {
    fill: var(--text) !important;
}

/* Urgent / Alert Cards in Light and Dark Mode */
.kpi-card-urgent {
    background-color: #FFF1F2 !important;
    border-color: #FECDD3 !important;
}
.dark .kpi-card-urgent,
[data-theme="dark"] .kpi-card-urgent {
    background-color: rgba(225, 29, 72, 0.12) !important;
    border-color: rgba(244, 63, 94, 0.3) !important;
}

.card-urgent-surface {
    background-color: #FFF5F5 !important;
    border-color: #FECDD3 !important;
}
.dark .card-urgent-surface,
[data-theme="dark"] .card-urgent-surface {
    background-color: rgba(225, 29, 72, 0.08) !important;
    border-color: rgba(244, 63, 94, 0.25) !important;
}

/* 6-Card KPI Horizontal Grid with Guaranteed Responsiveness */
.kpi-cards-grid {
    display: grid !important;
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
    gap: 0.875rem !important;
    width: 100% !important;
}

@media (max-width: 1400px) {
    .kpi-cards-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
}

@media (max-width: 768px) {
    .kpi-cards-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
}

@media (max-width: 480px) {
    .kpi-cards-grid {
        grid-template-columns: 1fr !important;
    }
}

.selection\\:bg-\\[var\\(--accent-soft\\)\\] *::selection{
  background-color: var(--accent-soft);
}

.selection\\:text-\\[var\\(--accent\\)\\] *::selection{
  color: var(--accent);
}

.selection\\:bg-\\[var\\(--accent-soft\\)\\]::selection{
  background-color: var(--accent-soft);
}

.selection\\:text-\\[var\\(--accent\\)\\]::selection{
  color: var(--accent);
}

.placeholder\\:text-\\[var\\(--text-faint\\)\\]::placeholder{
  color: var(--text-faint);
}

.placeholder\\:text-slate-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.focus-within\\:border-\\[var\\(--border-active\\)\\]:focus-within{
  border-color: var(--border-active);
}

.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-\\[var\\(--accent-soft\\)\\]:focus-within{
  --tw-ring-color: var(--accent-soft);
}

.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[\\#C9A76A\\]\\/30:hover{
  border-color: rgb(201 167 106 / 0.3);
}

.hover\\:border-\\[var\\(--border-active\\)\\]:hover{
  border-color: var(--border-active);
}

.hover\\:border-amber-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}

.hover\\:border-cyan-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}

.hover\\:border-emerald-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}

.hover\\:border-emerald-500\\/40:hover{
  border-color: rgb(16 185 129 / 0.4);
}

.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-rose-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}

.hover\\:bg-\\[\\#0d4635\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(13 70 53 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[var\\(--accent-hover\\)\\]:hover{
  background-color: var(--accent-hover);
}

.hover\\:bg-\\[var\\(--accent-soft\\)\\]:hover{
  background-color: var(--accent-soft);
}

.hover\\:bg-\\[var\\(--surface-2\\)\\]:hover{
  background-color: var(--surface-2);
}

.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-200\\/50:hover{
  background-color: rgb(167 243 208 / 0.5);
}

.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-500\\/10:hover{
  background-color: rgb(16 185 129 / 0.1);
}

.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-500\\/10:hover{
  background-color: rgb(99 102 241 / 0.1);
}

.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-100\\/40:hover{
  background-color: rgb(255 228 230 / 0.4);
}

.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-500\\/10:hover{
  background-color: rgb(244 63 94 / 0.1);
}

.hover\\:bg-rose-500\\/20:hover{
  background-color: rgb(244 63 94 / 0.2);
}

.hover\\:bg-rose-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50\\/80:hover{
  background-color: rgb(248 250 252 / 0.8);
}

.hover\\:bg-slate-500\\/10:hover{
  background-color: rgb(100 116 139 / 0.1);
}

.hover\\:bg-slate-500\\/5:hover{
  background-color: rgb(100 116 139 / 0.05);
}

.hover\\:bg-slate-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-700\\/60:hover{
  background-color: rgb(51 65 85 / 0.6);
}

.hover\\:bg-slate-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-800\\/40:hover{
  background-color: rgb(30 41 59 / 0.4);
}

.hover\\:bg-teal-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:text-\\[\\#F3EEE6\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(243 238 230 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[var\\(--text\\)\\]:hover{
  color: var(--text);
}

.hover\\:text-amber-600:hover{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-600:hover{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-700:hover{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-300:hover{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-600:hover{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-400:hover{
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-700:hover{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-600:hover{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-700:hover{
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-900:hover{
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:text-teal-600:hover{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:no-underline:hover{
  text-decoration-line: none;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-75:hover{
  opacity: 0.75;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:opacity-85:hover{
  opacity: 0.85;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:opacity-95:hover{
  opacity: 0.95;
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:z-10:focus{
  z-index: 10;
}

.focus\\:border-\\[var\\(--border-active\\)\\]:focus{
  border-color: var(--border-active);
}

.focus\\:border-emerald-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}

.focus\\:border-emerald-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}

.focus\\:border-gray-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-700:focus{
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity, 1));
}

.focus\\:border-rose-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}

.focus\\:border-white:focus{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.focus\\:bg-\\[var\\(--surface\\)\\]:focus{
  background-color: var(--surface);
}

.focus\\:bg-indigo-100:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.focus\\:text-gray-700:focus{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.focus\\:text-indigo-700:focus{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.focus\\:text-indigo-800:focus{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[var\\(--accent-soft\\)\\]:focus{
  --tw-ring-color: var(--accent-soft);
}

.focus\\:ring-\\[var\\(--border-active\\)\\]:focus{
  --tw-ring-color: var(--border-active);
}

.focus\\:ring-blue-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-emerald-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-emerald-500\\/20:focus{
  --tw-ring-color: rgb(16 185 129 / 0.2);
}

.focus\\:ring-indigo-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-500\\/20:focus{
  --tw-ring-color: rgb(99 102 241 / 0.2);
}

.focus\\:ring-rose-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 63 94 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-slate-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(148 163 184 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-opacity-50:focus{
  --tw-ring-opacity: 0.5;
}

.focus\\:ring-offset-1:focus{
  --tw-ring-offset-width: 1px;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-\\[var\\(--border-active\\)\\]:focus-visible{
  --tw-ring-color: var(--border-active);
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.active\\:scale-100:active{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.99\\]:active{
  --tw-scale-x: 0.99;
  --tw-scale-y: 0.99;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:bg-\\[var\\(--accent-hover\\)\\]:active{
  background-color: var(--accent-hover);
}

.active\\:bg-\\[var\\(--accent-soft\\)\\]:active{
  background-color: var(--accent-soft);
}

.active\\:bg-emerald-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.active\\:bg-rose-700:active{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}

.active\\:opacity-100:active{
  opacity: 1;
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-45:disabled{
  opacity: 0.45;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-\\[\\#C9A76A\\]\\/40{
  border-color: rgb(201 167 106 / 0.4);
}

.group:hover .group-hover\\:text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:opacity-80{
  opacity: 0.8;
}

.peer:focus-visible ~ .peer-focus-visible\\:ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.peer:focus-visible ~ .peer-focus-visible\\:ring-\\[var\\(--border-active\\)\\]{
  --tw-ring-color: var(--border-active);
}

.dark\\:divide-rose-900\\/30:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(136 19 55 / 0.3);
}

.dark\\:divide-white\\/5:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(255 255 255 / 0.05);
}

.dark\\:border-\\[\\#2B3531\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(43 53 49 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-500\\/20:is(.dark *){
  border-color: rgb(245 158 11 / 0.2);
}

.dark\\:border-amber-800\\/50:is(.dark *){
  border-color: rgb(146 64 14 / 0.5);
}

.dark\\:border-amber-800\\/60:is(.dark *){
  border-color: rgb(146 64 14 / 0.6);
}

.dark\\:border-emerald-500\\/20:is(.dark *){
  border-color: rgb(16 185 129 / 0.2);
}

.dark\\:border-emerald-800\\/40:is(.dark *){
  border-color: rgb(6 95 70 / 0.4);
}

.dark\\:border-emerald-800\\/50:is(.dark *){
  border-color: rgb(6 95 70 / 0.5);
}

.dark\\:border-emerald-800\\/60:is(.dark *){
  border-color: rgb(6 95 70 / 0.6);
}

.dark\\:border-emerald-800\\/80:is(.dark *){
  border-color: rgb(6 95 70 / 0.8);
}

.dark\\:border-indigo-800\\/60:is(.dark *){
  border-color: rgb(55 48 163 / 0.6);
}

.dark\\:border-purple-800\\/60:is(.dark *){
  border-color: rgb(107 33 168 / 0.6);
}

.dark\\:border-red-900\\/60:is(.dark *){
  border-color: rgb(127 29 29 / 0.6);
}

.dark\\:border-rose-500\\/20:is(.dark *){
  border-color: rgb(244 63 94 / 0.2);
}

.dark\\:border-rose-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity, 1));
}

.dark\\:border-rose-800\\/50:is(.dark *){
  border-color: rgb(159 18 57 / 0.5);
}

.dark\\:border-rose-800\\/60:is(.dark *){
  border-color: rgb(159 18 57 / 0.6);
}

.dark\\:border-rose-900\\/30:is(.dark *){
  border-color: rgb(136 19 55 / 0.3);
}

.dark\\:border-rose-900\\/40:is(.dark *){
  border-color: rgb(136 19 55 / 0.4);
}

.dark\\:border-rose-900\\/50:is(.dark *){
  border-color: rgb(136 19 55 / 0.5);
}

.dark\\:border-rose-900\\/60:is(.dark *){
  border-color: rgb(136 19 55 / 0.6);
}

.dark\\:border-slate-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}

.dark\\:border-slate-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}

.dark\\:border-slate-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}

.dark\\:border-teal-500\\/20:is(.dark *){
  border-color: rgb(20 184 166 / 0.2);
}

.dark\\:border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:border-white\\/20:is(.dark *){
  border-color: rgb(255 255 255 / 0.2);
}

.dark\\:border-white\\/5:is(.dark *){
  border-color: rgb(255 255 255 / 0.05);
}

.dark\\:border-white\\/\\[0\\.08\\]:is(.dark *){
  border-color: rgb(255 255 255 / 0.08);
}

.dark\\:border-zinc-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
}

.dark\\:bg-\\[\\#080E1E\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(8 14 30 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#111827\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#161F30\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(22 31 48 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#1E1E1E\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-amber-500\\/10:is(.dark *){
  background-color: rgb(245 158 11 / 0.1);
}

.dark\\:bg-amber-900\\/50:is(.dark *){
  background-color: rgb(120 53 15 / 0.5);
}

.dark\\:bg-amber-900\\/60:is(.dark *){
  background-color: rgb(120 53 15 / 0.6);
}

.dark\\:bg-amber-950\\/40:is(.dark *){
  background-color: rgb(69 26 3 / 0.4);
}

.dark\\:bg-amber-950\\/50:is(.dark *){
  background-color: rgb(69 26 3 / 0.5);
}

.dark\\:bg-black\\/75:is(.dark *){
  background-color: rgb(0 0 0 / 0.75);
}

.dark\\:bg-blue-900\\/60:is(.dark *){
  background-color: rgb(30 58 138 / 0.6);
}

.dark\\:bg-cyan-950\\/50:is(.dark *){
  background-color: rgb(8 51 68 / 0.5);
}

.dark\\:bg-emerald-500\\/10:is(.dark *){
  background-color: rgb(16 185 129 / 0.1);
}

.dark\\:bg-emerald-900\\/50:is(.dark *){
  background-color: rgb(6 78 59 / 0.5);
}

.dark\\:bg-emerald-900\\/60:is(.dark *){
  background-color: rgb(6 78 59 / 0.6);
}

.dark\\:bg-emerald-950\\/40:is(.dark *){
  background-color: rgb(2 44 34 / 0.4);
}

.dark\\:bg-emerald-950\\/50:is(.dark *){
  background-color: rgb(2 44 34 / 0.5);
}

.dark\\:bg-emerald-950\\/70:is(.dark *){
  background-color: rgb(2 44 34 / 0.7);
}

.dark\\:bg-gray-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-900\\/50:is(.dark *){
  background-color: rgb(49 46 129 / 0.5);
}

.dark\\:bg-indigo-950\\/40:is(.dark *){
  background-color: rgb(30 27 75 / 0.4);
}

.dark\\:bg-indigo-950\\/50:is(.dark *){
  background-color: rgb(30 27 75 / 0.5);
}

.dark\\:bg-purple-900\\/50:is(.dark *){
  background-color: rgb(88 28 135 / 0.5);
}

.dark\\:bg-purple-950\\/40:is(.dark *){
  background-color: rgb(59 7 100 / 0.4);
}

.dark\\:bg-purple-950\\/50:is(.dark *){
  background-color: rgb(59 7 100 / 0.5);
}

.dark\\:bg-red-950\\/40:is(.dark *){
  background-color: rgb(69 10 10 / 0.4);
}

.dark\\:bg-rose-500\\/10:is(.dark *){
  background-color: rgb(244 63 94 / 0.1);
}

.dark\\:bg-rose-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(136 19 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-rose-900\\/60:is(.dark *){
  background-color: rgb(136 19 55 / 0.6);
}

.dark\\:bg-rose-900\\/80:is(.dark *){
  background-color: rgb(136 19 55 / 0.8);
}

.dark\\:bg-rose-950\\/40:is(.dark *){
  background-color: rgb(76 5 25 / 0.4);
}

.dark\\:bg-rose-950\\/50:is(.dark *){
  background-color: rgb(76 5 25 / 0.5);
}

.dark\\:bg-slate-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-800\\/30:is(.dark *){
  background-color: rgb(30 41 59 / 0.3);
}

.dark\\:bg-slate-800\\/50:is(.dark *){
  background-color: rgb(30 41 59 / 0.5);
}

.dark\\:bg-slate-800\\/80:is(.dark *){
  background-color: rgb(30 41 59 / 0.8);
}

.dark\\:bg-slate-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-teal-500\\/10:is(.dark *){
  background-color: rgb(20 184 166 / 0.1);
}

.dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:bg-white\\/15:is(.dark *){
  background-color: rgb(255 255 255 / 0.15);
}

.dark\\:bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:bg-white\\/\\[0\\.01\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.01);
}

.dark\\:bg-white\\/\\[0\\.02\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.02);
}

.dark\\:bg-white\\/\\[0\\.04\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.04);
}

.dark\\:from-\\[\\#0c1412\\]:is(.dark *){
  --tw-gradient-from: #0c1412 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(12 20 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:via-\\[\\#111c19\\]:is(.dark *){
  --tw-gradient-to: rgb(17 28 25 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #111c19 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:to-\\[\\#080d0c\\]:is(.dark *){
  --tw-gradient-to: #080d0c var(--tw-gradient-to-position);
}

.dark\\:text-\\[\\#14110B\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(20 17 11 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:border-amber-800:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-cyan-800:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(21 94 117 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-emerald-800:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-indigo-800:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-rose-800:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-white\\/10:hover:is(.dark *){
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:border-white\\/20:hover:is(.dark *){
  border-color: rgb(255 255 255 / 0.2);
}

.dark\\:hover\\:bg-amber-950\\/40:hover:is(.dark *){
  background-color: rgb(69 26 3 / 0.4);
}

.dark\\:hover\\:bg-emerald-950\\/40:hover:is(.dark *){
  background-color: rgb(2 44 34 / 0.4);
}

.dark\\:hover\\:bg-indigo-950\\/40:hover:is(.dark *){
  background-color: rgb(30 27 75 / 0.4);
}

.dark\\:hover\\:bg-rose-900\\/20:hover:is(.dark *){
  background-color: rgb(136 19 55 / 0.2);
}

.dark\\:hover\\:bg-rose-950\\/40:hover:is(.dark *){
  background-color: rgb(76 5 25 / 0.4);
}

.dark\\:hover\\:bg-slate-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-slate-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-slate-800\\/60:hover:is(.dark *){
  background-color: rgb(30 41 59 / 0.6);
}

.dark\\:hover\\:bg-teal-950\\/40:hover:is(.dark *){
  background-color: rgb(4 47 46 / 0.4);
}

.dark\\:hover\\:bg-white\\/10:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:bg-white\\/5:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:hover\\:bg-white\\/\\[0\\.03\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.03);
}

.dark\\:hover\\:bg-white\\/\\[0\\.08\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.08);
}

.dark\\:hover\\:bg-zinc-800\\/50:hover:is(.dark *){
  background-color: rgb(39 39 42 / 0.5);
}

.dark\\:hover\\:text-indigo-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-slate-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-slate-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px){

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:ml-4{
    margin-left: 1rem;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline-block{
    display: inline-block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-11{
    height: 2.75rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-4{
    height: 1rem;
  }

  .sm\\:h-\\[190px\\]{
    height: 190px;
  }

  .sm\\:max-h-\\[calc\\(100vh-48px\\)\\]{
    max-height: calc(100vh - 48px);
  }

  .sm\\:min-h-\\[250px\\]{
    min-height: 250px;
  }

  .sm\\:w-11{
    width: 2.75rem;
  }

  .sm\\:w-4{
    width: 1rem;
  }

  .sm\\:w-64{
    width: 16rem;
  }

  .sm\\:w-72{
    width: 18rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-\\[190px\\]{
    width: 190px;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:gap-4{
    gap: 1rem;
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:self-auto{
    align-self: auto;
  }

  .sm\\:rounded-3xl{
    border-radius: 1.5rem;
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-12{
    padding: 3rem;
  }

  .sm\\:p-16{
    padding: 4rem;
  }

  .sm\\:p-3\\.5{
    padding: 0.875rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-7{
    padding: 1.75rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .sm\\:pt-0{
    padding-top: 0px;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-\\[11px\\]{
    font-size: 11px;
  }

  .sm\\:text-\\[26px\\]{
    font-size: 26px;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px){

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .md\\:ml-2{
    margin-left: 0.5rem;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:w-\\[240px\\]{
    width: 240px;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:gap-0{
    gap: 0px;
  }

  .md\\:divide-x > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px){

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:w-5\\/12{
    width: 41.666667%;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:justify-end{
    justify-content: flex-end;
  }

  .lg\\:gap-8{
    gap: 2rem;
  }

  .lg\\:p-12{
    padding: 3rem;
  }

  .lg\\:p-6{
    padding: 1.5rem;
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (min-width: 1280px){

  .xl\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .xl\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .xl\\:w-1\\/2{
    width: 50%;
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:p-16{
    padding: 4rem;
  }

  .xl\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .xl\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .xl\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,wIAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,iIAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,wCAAc;EAAd,4BAAc;EAAd,4BAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yDAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,yBAAc;EAAd,8BAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,4BAAc;AAAA;;AAAd;;EAAA;IAAA;EAAc;AAAA;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA,6BAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA,gBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,iBAAoB;EAApB,kBAAoB;EAApB,mBAAoB;EAApB,sBAAoB;EAApB,sBAAoB;EAApB,qBAAoB;EAApB,eAAoB;EAApB,mBAAoB;EAApB,sBAAoB;AAAA;AAApB;EAAA,8BAAoB;EAApB,mBAAoB;EAApB,4CAAoB;EAApB,2BAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,2GAAoB;EAApB,yGAAoB;EAApB,iFAAoB;EAApB;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB;AAAoB;AAApB;EAAA,yDAAoB;EAApB,wCAAoB;EAApB,4BAAoB;EAApB,4BAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;EAAA,yBAAoB;EAApB,4BAAoB;EAApB,wBAAoB;EAApB,wBAAoB;EAApB,sBAAoB;EAApB;AAAoB;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;iEAEiE;;AAEjE;;IAEI,0DAA0D;IAC1D,oGAAoG;IACpG,qDAAqD;;IAErD,iCAAiC,MAAM,sCAAsC;IAC7E,kCAAkC,KAAK,iCAAiC;IACxE,8BAA8B,SAAS,uCAAuC;IAC9E,kCAAkC,KAAK,qCAAqC;IAC5E,gCAAgC,OAAO,uBAAuB;IAC9D,qDAAqD,EAAE,0BAA0B;IACjF,8BAA8B,SAAS,oCAAoC;IAC3E,kDAAkD,EAAE,oCAAoC;;IAExF,6BAA6B;IAC7B,6BAA6B;;IAE7B,gDAAgD;IAChD,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;;IAE7B,kBAAkB;IAClB,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;;IAE7B,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,+BAA+B;;IAE/B,iDAAiD;IACjD,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,uCAAuC;IACvC,0FAA0F;IAC1F,gEAAgE;;IAEhE,mCAAmC;IACnC,mCAAmC;IACnC,wCAAwC;IACxC,0CAA0C;IAC1C,wCAAwC;IACxC,0CAA0C;IAC1C,wCAAwC;IACxC,wCAAwC;IACxC,0CAA0C;IAC1C,qCAAqC;IACrC,qCAAqC;IACrC,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,uCAAuC;IACvC,8CAA8C;IAC9C,uCAAuC;IACvC,uCAAuC;;IAEvC,uCAAuC;IACvC,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,uCAAuC;;IAEvC,4CAA4C;IAC5C,uCAAuC;;IAEvC,wCAAwC;IACxC,uCAAuC;IACvC,uCAAuC;IACvC,2CAA2C;;IAE3C,0CAA0C;IAC1C,2CAA2C;IAC3C,0CAA0C;IAC1C,uCAAuC;;IAEvC,gDAAgD;IAChD,0CAA0C;IAC1C,qCAAqC;;IAErC,wCAAwC;IACxC,6CAA6C;IAC7C,wCAAwC;IACxC,6CAA6C;IAC7C,uCAAuC;IACvC,4CAA4C;IAC5C,qCAAqC;IACrC,0CAA0C;;IAE1C,0DAA0D;IAC1D,iGAAiG;AACrG;;AAEA;;IAEI,0DAA0D;IAC1D,oGAAoG;IACpG,qDAAqD;;IAErD,iCAAiC,MAAM,sCAAsC;IAC7E,kCAAkC,KAAK,iCAAiC;IACxE,8BAA8B,SAAS,uCAAuC;IAC9E,kCAAkC,KAAK,qCAAqC;IAC5E,gCAAgC,OAAO,uBAAuB;IAC9D,qDAAqD,EAAE,0BAA0B;IACjF,8BAA8B,SAAS,oCAAoC;IAC3E,kDAAkD,EAAE,oCAAoC;;IAExF,6BAA6B;IAC7B,6BAA6B;;IAE7B,+CAA+C;IAC/C,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;;IAE7B,kBAAkB;IAClB,6BAA6B;IAC7B,6CAA6C;IAC7C,6BAA6B;IAC7B,8CAA8C;IAC9C,6BAA6B;IAC7B,6CAA6C;IAC7C,6BAA6B;IAC7B,8CAA8C;;IAE9C,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;IAC7B,+BAA+B;;IAE/B,kDAAkD;IAClD,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,uCAAuC;IACvC,2FAA2F;IAC3F,iEAAiE;;IAEjE,mCAAmC;IACnC,mCAAmC;IACnC,wCAAwC;IACxC,0CAA0C;IAC1C,wCAAwC;IACxC,0CAA0C;IAC1C,wCAAwC;IACxC,wCAAwC;IACxC,0CAA0C;IAC1C,qCAAqC;IACrC,qCAAqC;IACrC,2CAA2C;IAC3C,2CAA2C;IAC3C,2CAA2C;IAC3C,uCAAuC;IACvC,8CAA8C;IAC9C,uCAAuC;IACvC,uCAAuC;;IAEvC,uCAAuC;IACvC,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,uCAAuC;;IAEvC,4CAA4C;IAC5C,uCAAuC;;IAEvC,0CAA0C;IAC1C,uCAAuC;IACvC,uCAAuC;IACvC,2CAA2C;;IAE3C,0CAA0C;IAC1C,2CAA2C;IAC3C,0CAA0C;IAC1C,uCAAuC;;IAEvC,gDAAgD;IAChD,0CAA0C;IAC1C,qCAAqC;;IAErC,wCAAwC;IACxC,6CAA6C;IAC7C,wCAAwC;IACxC,6CAA6C;IAC7C,uCAAuC;IACvC,4CAA4C;IAC5C,qCAAqC;IACrC,0CAA0C;;IAE1C,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;;iEAEiE;;AAEjE;;;;EAIE;AACF;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;IAChC;;iGAE6F;IAC7F,0CAA0C;IAC1C,wCAAwC;IACxC,6BAA6B;IAC7B,iCAAiC;IACjC;;;mEAG+D;AACnE;;AAEA,6BAA6B;AAC7B;IACI,eAAe;AACnB;AACA;IACI,oDAAoD;IACpD,6BAA6B;AACjC;;AAEA,iCAAiC;AACjC;;IAEI,6CAA6C;IAC7C,iCAAiC;IACjC,2CAA2C;IAC3C,6FAA6F;AACjG;;AAEA,8DAA8D;AAC9D;IACI,sCAAsC;IACtC,+BAA+B;IAC/B,kCAAkC;IAClC,iCAAiC;IACjC,0DAA0D;AAC9D;AACA;IACI,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA,qDAAqD;AACrD;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,qCAAqC;IACrC,yCAAyC;IACzC,aAAa;IACb,oBAAoB;IACpB,mEAAmE;AACvE;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA,uCAAuC;AACvC;IACI,wBAAwB;IACxB,2DAA2D;IAC3D,uBAAuB;AAC3B;;AAEA;IACI;QACI,2DAA2D;QAC3D,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,WAAW;IACX,uFAAuF;IACvF,YAAY;IACZ,SAAS;IACT,cAAc;AAClB;;AAEA;;iEAEiE;;AAEjE;IACI,uFAAuF;IACvF,kBAAkB;IAClB,2BAA2B;IAC3B,SAAS;IACT,UAAU;IACV,mCAAmC;IACnC,kCAAkC;IAClC,yDAAyD;AAC7D;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,SAAS;IACT,UAAU;AACd;;AAEA,sDAAsD;AACtD;;;;;;;;;IASI,kFAAkF;AACtF;;AAEA;IACI;QACI,sCAAsC;QACtC,qCAAqC;IACzC;AACJ;;AAEA,+BAA+B;AAC/B;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA,yBAAyB;AACzB;IACI,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,uCAAuC;IACvC,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;;;IAII,6BAA6B;AACjC;;AAEA;;iEAEiE;;AAEjE;IACI,wCAAwC;IACxC,2CAA2C;IAC3C,6BAA6B;IAC7B,0CAA0C;IAC1C,iDAAiD;IACjD,kFAAkF;AACtF;AACA;IACI,8CAA8C;AAClD;AACA;IACI,6CAA6C;AACjD;AACA;IACI,8CAA8C;AAClD;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;;AAEA,6BAA6B;AAC7B;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,6BAA6B;AACjC;;AAEA,0BAA0B;AAC1B;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;;iEAEiE;;AAEjE;IACI,OAAO,6BAA6B,EAAE;IACtC,OAAO,4BAA4B,EAAE;AACzC;;AAEA;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA;IACI,OAAO,UAAU,EAAE,uCAAuC,EAAE;IAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AAC1D;;AAEA;IACI,WAAW,UAAU,EAAE,mBAAmB,EAAE;IAC5C,WAAW,YAAY,EAAE,qBAAqB,EAAE;AACpD;;AAEA;IACI,gGAAgG;IAChG,2BAA2B;IAC3B,mDAAmD;AACvD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,mEAAmE;AACvE;;AAEA;IACI,mDAAmD;AACvD;;AAEA;;iEAEiE;;AAEjE;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,6DAA6D;IAC7D,6BAA6B;IAC7B,2BAA2B;IAC3B,oCAAoC;IACpC,iCAAiC;IACjC,sCAAsC;IACtC,0DAA0D;IAC1D,uDAAuD;IACvD,8BAA8B;IAC9B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,mCAAmC;IACnC,uDAAuD;IACvD,uCAAuC;AAC3C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;iEAEiE;;AAEjE;;;;;;;;IAQI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,sCAAsC;IACtC,+BAA+B;IAC/B,aAAa;IACb,iCAAiC;IACjC,uIAAuI;AAC3I;;AAEA;IACI,+BAA+B,EAAE,gCAAgC;AACrE;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;IAGI,2CAA2C;IAC3C,6CAA6C;IAC7C,mFAAmF;AACvF;;AAEA;IACI,iDAAiD;IACjD,0CAA0C;IAC1C,6BAA6B;IAC7B,8BAA8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,6DAA6D;IAC7D,6BAA6B;IAC7B,2BAA2B;IAC3B,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;;iEAEiE;;AAEjE;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,2CAA2C;IAC3C;;4GAEwG;IACxG,qDAAqD;IACrD,mDAAmD;IACnD,wCAAwC;IACxC,4CAA4C;AAChD;;AAEA;IACI,wCAAwC;IACxC,wDAAwD;IACxD,6BAA6B;AACjC;;AAEA,gCAAgC;AAChC;IACI,oCAAoC;IACpC,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA,2BAA2B;AAC3B;IACI,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA;;IAEI,yCAAyC;IACzC,2CAA2C;AAC/C;;AAEA,uBAAuB;AACvB;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,mCAAmC;AACvC;AACA;IACI,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA,iFAAiF;AACjF;;;;;;;IAOI,wCAAwC;IACxC,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA,mDAAmD;AACnD;IACI,6BAA6B;IAC7B,wCAAwC;IACxC,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;;;;;;;;IAQI,wBAAwB;IACxB,2BAA2B;IAC3B,uBAAuB;IACvB,wCAAwC;AAC5C;;AAEA,iDAAiD;AACjD;;;;IAII,kEAAkE;IAClE,+CAA+C;IAC/C,yDAAiD;IAAjD,iDAAiD;AACrD;;AAEA,8BAA8B;AAC9B;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,0CAA0C;IAC1C,8BAA8B;IAC9B,qDAAqD;AACzD;AACA;IACI,6BAA6B;AACjC;AACA;IACI,mCAAmC;AACvC;AACA,mCAAmC,qCAAqC,EAAE;AAC1E,mCAAmC,qCAAqC,EAAE;AAC1E,mCAAmC,qCAAqC,EAAE;AAC1E,mCAAmC,qCAAqC,EAAE;;AAE1E,oCAAoC;AACpC;IACI;QACI,UAAU;QACV,wCAAwC;IAC5C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;AACA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;AACA;IACI,qEAAqE;AACzE;AACA;IACI,+CAA+C;AACnD;;AAEA;;iEAEiE;;AAEjE;;IAEI,2CAA2C;IAC3C,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;;IAEI,6CAA6C;IAC7C,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA,yDAAyD;AACzD;;;;IAII,2CAA2C;IAC3C,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;;;;IAII,6CAA6C;IAC7C,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA,gDAAgD;AAChD;IACI,oCAAoC;IACpC,gCAAgC;AACpC;AACA;;IAEI,oDAAoD;IACpD,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;AACA;;IAEI,oDAAoD;IACpD,gDAAgD;AACpD;;AAEA,8DAA8D;AAC9D;IACI,wBAAwB;IACxB,2DAA2D;IAC3D,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI;QACI,2DAA2D;IAC/D;AACJ;;AAEA;IACI;QACI,2DAA2D;IAC/D;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AA11BA;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,2GA01BE;EA11BF,yGA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,2BA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,+EA01BE;EA11BF,mGA01BE;EA11BF;AA01BE;;AA11BF;EAAA,6EA01BE;EA11BF,iGA01BE;EA11BF;AA01BE;;AA11BF;EAAA,0CA01BE;EA11BF,uDA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,8BA01BE;EA11BF;AA01BE;;AA11BF;EAAA,2GA01BE;EA11BF,yGA01BE;EA11BF;AA01BE;;AA11BF;EAAA,2GA01BE;EA11BF,yGA01BE;EA11BF;AA01BE;;AA11BF;EAAA,2GA01BE;EA11BF,yGA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,8BA01BE;EA11BF;AA01BE;;AA11BF;EAAA,2GA01BE;EA11BF,yGA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,eA01BE;EA11BF,eA01BE;EA11BF;AA01BE;;AA11BF;EAAA,iBA01BE;EA11BF,iBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,2GA01BE;EA11BF,yGA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,4DA01BE;EA11BF,kEA01BE;EA11BF;AA01BE;;AA11BF;EAAA,mEA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,sBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,kBA01BE;EA11BF;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;EAAA,oBA01BE;EA11BF;AA01BE;;AA11BF;;EAAA;IAAA;EA01BE;;EA11BF;IAAA,gBA01BE;IA11BF;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA,uBA01BE;IA11BF,+DA01BE;IA11BF;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA,oBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,kBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,iBA01BE;IA11BF;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA,iBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,mBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,kBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,eA01BE;IA11BF;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA,eA01BE;IA11BF;EA01BE;;EA11BF;IAAA,mBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,mBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,kBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,kBA01BE;IA11BF;EA01BE;AAAA;;AA11BF;;EAAA;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA,wBA01BE;IA11BF,0DA01BE;IA11BF;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA,oBA01BE;IA11BF;EA01BE;AAAA;;AA11BF;;EAAA;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA,kBA01BE;IA11BF;EA01BE;AAAA;;AA11BF;;EAAA;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA;EA01BE;;EA11BF;IAAA,eA01BE;IA11BF;EA01BE;;EA11BF;IAAA,kBA01BE;IA11BF;EA01BE;;EA11BF;IAAA,mBA01BE;IA11BF;EA01BE;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ============================================================\n   SILENCE & GOLD DESIGN TOKENS (LIGHT & DARK MODES)\n   ============================================================ */\n\n:root,\n[data-theme=\"light\"] {\n    /* Typography System Tokens (ONE Font Family Everywhere) */\n    --font-sans:              'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    --font-mono:              'JetBrains Mono', monospace;\n\n    --text-xs:                0.75rem;     /* 12px - labels, micro-copy, badges */\n    --text-sm:                0.875rem;    /* 14px - body, buttons, inputs */\n    --text-base:              1rem;        /* 16px - section titles, subheadings */\n    --text-lg:                1.125rem;    /* 18px - card titles, large labels */\n    --text-xl:                1.5rem;      /* 24px - page titles */\n    --text-kpi:               clamp(1.75rem, 2.5vw, 2rem); /* 28-32px - KPI metrics */\n    --text-2xl:               2rem;        /* 32px - marketing section titles */\n    --text-3xl:               clamp(2.5rem, 5vw, 3rem); /* 40-48px - landing hero headline */\n\n    --line-height-body:       1.4;\n    --line-height-heading:    1.2;\n\n    /* Canonical Tokens - Clean SaaS Light Palette */\n    --bg:                 #F8FAFC;\n    --surface:            #FFFFFF;\n    --surface-2:          #F1F5F9;\n    --border:             #E2E8F0;\n    --text:               #0F172A;\n    --text-muted:         #64748B;\n    --text-faint:         #94A3B8;\n    --accent:             #4F46E5;\n    --accent-hover:       #4338CA;\n    --accent-soft:        #EEF2FF;\n    --on-accent:          #FFFFFF;\n\n    /* Status Tokens */\n    --success:            #16A34A;\n    --success-soft:       #DCFCE7;\n    --warning:            #D97706;\n    --warning-soft:       #FEF3C7;\n    --danger:             #DC2626;\n    --danger-soft:        #FEE2E2;\n    --info:               #0284C7;\n    --info-soft:          #E0F2FE;\n\n    /* Border & Radius System Tokens */\n    --radius-lg:              12px;\n    --radius-md:              8px;\n    --radius-pill:            999px;\n\n    --border-gradient-start:  rgba(79, 70, 229, 0.35);\n    --border-gradient-end:    #E2E8F0;\n    --border-subtle:          #E2E8F0;\n    --border-strong:          #CBD5E1;\n    --border-active:          var(--accent);\n    --glow-hover:             0 0 0 1px var(--accent-soft), 0 4px 12px rgba(79, 70, 229, 0.08);\n    --edge-highlight:         inset 0 1px 0 rgba(255, 255, 255, 0.9);\n\n    /* Mapped Compatibility Variables */\n    --color-bg:               var(--bg);\n    --color-surface:          var(--surface);\n    --color-surface-secondary:var(--surface-2);\n    --color-card:             var(--surface);\n    --color-card-hover:       var(--surface-2);\n    --color-sidebar:          var(--surface);\n    --color-header:           var(--surface);\n    --color-control:          var(--surface-2);\n    --color-text:             var(--text);\n    --color-heading:          var(--text);\n    --color-text-secondary:   var(--text-muted);\n    --color-subtext:          var(--text-muted);\n    --color-text-muted:       var(--text-faint);\n    --color-border:           var(--border);\n    --color-border-subtle:    var(--border-subtle);\n    --color-border-solid:     var(--border);\n    --color-divider:          var(--border);\n\n    --color-primary:          var(--accent);\n    --color-primary-hover:    var(--accent-hover);\n    --color-primary-light:    var(--accent-soft);\n    --color-primary-dark:     var(--accent-hover);\n    --color-primary-mid:      var(--accent);\n\n    --color-badge:            var(--accent-soft);\n    --color-badge-text:       var(--accent);\n\n    --color-input-bg:         var(--surface);\n    --color-input-border:     var(--border);\n    --color-input-focus:      var(--accent);\n    --color-input-placeholder:var(--text-faint);\n\n    --color-table-header-bg:  var(--surface-2);\n    --color-table-header-text:var(--text-muted);\n    --color-table-row-hover:  var(--surface-2);\n    --color-table-border:     var(--border);\n\n    --color-overlay:          rgba(23, 21, 15, 0.45);\n    --color-tooltip-bg:       var(--surface-2);\n    --color-tooltip-text:     var(--text);\n\n    --color-success:          var(--success);\n    --color-success-light:    var(--success-soft);\n    --color-warning:          var(--warning);\n    --color-warning-light:    var(--warning-soft);\n    --color-error:            var(--danger);\n    --color-error-light:      var(--danger-soft);\n    --color-info:             var(--info);\n    --color-info-light:       var(--info-soft);\n\n    --shadow-soft-sm:         0 1px 3px rgba(23, 21, 15, 0.05);\n    --shadow-card:            0 1px 3px rgba(23, 21, 15, 0.04), 0 1px 2px -1px rgba(23, 21, 15, 0.03);\n}\n\n.dark,\n[data-theme=\"dark\"] {\n    /* Typography System Tokens (ONE Font Family Everywhere) */\n    --font-sans:              'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    --font-mono:              'JetBrains Mono', monospace;\n\n    --text-xs:                0.75rem;     /* 12px - labels, micro-copy, badges */\n    --text-sm:                0.875rem;    /* 14px - body, buttons, inputs */\n    --text-base:              1rem;        /* 16px - section titles, subheadings */\n    --text-lg:                1.125rem;    /* 18px - card titles, large labels */\n    --text-xl:                1.5rem;      /* 24px - page titles */\n    --text-kpi:               clamp(1.75rem, 2.5vw, 2rem); /* 28-32px - KPI metrics */\n    --text-2xl:               2rem;        /* 32px - marketing section titles */\n    --text-3xl:               clamp(2.5rem, 5vw, 3rem); /* 40-48px - landing hero headline */\n\n    --line-height-body:       1.4;\n    --line-height-heading:    1.2;\n\n    /* Canonical Tokens - Clean SaaS Dark Palette */\n    --bg:                 #0B1120;\n    --surface:            #111827;\n    --surface-2:          #1E293B;\n    --border:             #1F2937;\n    --text:               #F1F5F9;\n    --text-muted:         #94A3B8;\n    --text-faint:         #64748B;\n    --accent:             #6366F1;\n    --accent-hover:       #818CF8;\n    --accent-soft:        #1E1B4B;\n    --on-accent:          #FFFFFF;\n\n    /* Status Tokens */\n    --success:            #22C55E;\n    --success-soft:       rgba(34, 197, 94, 0.16);\n    --warning:            #F59E0B;\n    --warning-soft:       rgba(245, 158, 11, 0.16);\n    --danger:             #EF4444;\n    --danger-soft:        rgba(239, 68, 68, 0.16);\n    --info:               #38BDF8;\n    --info-soft:          rgba(56, 189, 248, 0.16);\n\n    /* Border & Radius System Tokens */\n    --radius-lg:              12px;\n    --radius-md:              8px;\n    --radius-pill:            999px;\n\n    --border-gradient-start:  rgba(99, 102, 241, 0.35);\n    --border-gradient-end:    #1F2937;\n    --border-subtle:          #1F2937;\n    --border-strong:          #374151;\n    --border-active:          var(--accent);\n    --glow-hover:             0 0 0 1px var(--accent-soft), 0 4px 12px rgba(99, 102, 241, 0.12);\n    --edge-highlight:         inset 0 1px 0 rgba(255, 255, 255, 0.05);\n\n    /* Mapped Compatibility Variables */\n    --color-bg:               var(--bg);\n    --color-surface:          var(--surface);\n    --color-surface-secondary:var(--surface-2);\n    --color-card:             var(--surface);\n    --color-card-hover:       var(--surface-2);\n    --color-sidebar:          var(--surface);\n    --color-header:           var(--surface);\n    --color-control:          var(--surface-2);\n    --color-text:             var(--text);\n    --color-heading:          var(--text);\n    --color-text-secondary:   var(--text-muted);\n    --color-subtext:          var(--text-muted);\n    --color-text-muted:       var(--text-faint);\n    --color-border:           var(--border);\n    --color-border-subtle:    var(--border-subtle);\n    --color-border-solid:     var(--border);\n    --color-divider:          var(--border);\n\n    --color-primary:          var(--accent);\n    --color-primary-hover:    var(--accent-hover);\n    --color-primary-light:    var(--accent-soft);\n    --color-primary-dark:     var(--accent-hover);\n    --color-primary-mid:      var(--accent);\n\n    --color-badge:            var(--accent-soft);\n    --color-badge-text:       var(--accent);\n\n    --color-input-bg:         var(--surface-2);\n    --color-input-border:     var(--border);\n    --color-input-focus:      var(--accent);\n    --color-input-placeholder:var(--text-faint);\n\n    --color-table-header-bg:  var(--surface-2);\n    --color-table-header-text:var(--text-muted);\n    --color-table-row-hover:  var(--surface-2);\n    --color-table-border:     var(--border);\n\n    --color-overlay:          rgba(11, 11, 12, 0.85);\n    --color-tooltip-bg:       var(--surface-2);\n    --color-tooltip-text:     var(--text);\n\n    --color-success:          var(--success);\n    --color-success-light:    var(--success-soft);\n    --color-warning:          var(--warning);\n    --color-warning-light:    var(--warning-soft);\n    --color-error:            var(--danger);\n    --color-error-light:      var(--danger-soft);\n    --color-info:             var(--info);\n    --color-info-light:       var(--info-soft);\n\n    --shadow-soft-sm:         none;\n    --shadow-card:            none;\n}\n\n/* ============================================================\n   REUSABLE PREMIUM BORDER SYSTEM (TASK A)\n   ============================================================ */\n\n/**\n * .card-border\n * Dual-layer background gradient hairline border with glass edge highlight.\n * High performance, zero layout shift, seamless rounded corners.\n */\n.card-border {\n    position: relative;\n    border-radius: var(--radius-lg);\n    background-color: var(--surface);\n    background-image: \n        linear-gradient(var(--surface), var(--surface)), \n        linear-gradient(135deg, var(--border-gradient-start) 0%, var(--border-gradient-end) 100%);\n    background-origin: padding-box, border-box;\n    background-clip: padding-box, border-box;\n    border: 1px solid transparent;\n    box-shadow: var(--edge-highlight);\n    transition: box-shadow 180ms cubic-bezier(0.4, 0, 0.2, 1),\n                border-color 180ms cubic-bezier(0.4, 0, 0.2, 1),\n                transform 180ms cubic-bezier(0.4, 0, 0.2, 1),\n                background-color 180ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Interactive Card Variant */\n.card-border-interactive {\n    cursor: pointer;\n}\n.card-border-interactive:hover {\n    box-shadow: var(--edge-highlight), var(--glow-hover);\n    transform: translateY(-1.5px);\n}\n\n/* Active / Selected Card State */\n.card-border-active,\n.card-border.is-active {\n    border-color: var(--border-active) !important;\n    background-image: none !important;\n    background-color: var(--surface) !important;\n    box-shadow: var(--edge-highlight), 0 0 0 1px var(--accent-soft), var(--glow-hover) !important;\n}\n\n/* Subtle Card Variant (for nested frames, inputs, toolbars) */\n.card-border-subtle {\n    border: 1px solid var(--border-subtle);\n    border-radius: var(--radius-md);\n    background-color: var(--surface-2);\n    box-shadow: var(--edge-highlight);\n    transition: border-color 180ms ease, box-shadow 180ms ease;\n}\n.card-border-subtle:focus-within {\n    border-color: var(--border-active);\n    box-shadow: 0 0 0 2px var(--accent-soft);\n}\n\n/* Tiny Gold Corner Accent (Strictly for KPI cards) */\n.kpi-corner-accent {\n    position: relative;\n    overflow: hidden;\n}\n.kpi-corner-accent::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 14px;\n    height: 14px;\n    border-top: 2px solid var(--accent);\n    border-right: 2px solid var(--accent);\n    border-top-right-radius: var(--radius-lg);\n    opacity: 0.85;\n    pointer-events: none;\n    transition: opacity 180ms ease, width 180ms ease, height 180ms ease;\n}\n.kpi-corner-accent:hover::after {\n    opacity: 1;\n    width: 18px;\n    height: 18px;\n}\n\n/* Strict 3 columns x 2 rows KPI Grid */\n.kpi-3x2-grid {\n    display: grid !important;\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    gap: 1.25rem !important;\n}\n\n@media (max-width: 768px) {\n    .kpi-3x2-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n        gap: 1rem !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .kpi-3x2-grid {\n        grid-template-columns: 1fr !important;\n    }\n}\n\n/* Fading Gradient Divider */\n.divider-gradient {\n    height: 1px;\n    width: 100%;\n    background: linear-gradient(90deg, transparent 0%, var(--border) 50%, transparent 100%);\n    border: none;\n    margin: 0;\n    flex-shrink: 0;\n}\n\n/* ============================================================\n   GLOBAL TYPOGRAPHY, THEME TRANSITIONS & BASE RESETS\n   ============================================================ */\n\nhtml {\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    color: var(--text);\n    background-color: var(--bg);\n    margin: 0;\n    padding: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    transition: background-color 180ms ease, color 180ms ease;\n}\n\nbody {\n    color: var(--text);\n    background-color: var(--bg);\n    margin: 0;\n    padding: 0;\n}\n\n/* Smooth theme transitions on core surface elements */\nbody,\n.ddwoms-main,\n.ddwoms-sidebar,\n.ddwoms-sidebar-header,\n.ddwoms-sidebar-footer,\nnav,\nfooter,\n.card,\ntable {\n    transition: background-color 180ms ease, color 180ms ease, border-color 180ms ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    html, body, *, *::before, *::after {\n        transition-duration: 0.01ms !important;\n        animation-duration: 0.01ms !important;\n    }\n}\n\n/* Native selection highlight */\n::selection {\n    background-color: var(--accent-soft);\n    color: var(--accent);\n}\n\n/* Keyboard focus rings */\n:focus-visible {\n    outline: 2px solid var(--accent) !important;\n    outline-offset: 2px;\n}\n\n/* Native checkbox and radio color */\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n    accent-color: var(--accent);\n}\n\nh1, h2, h3, h4, h5, h6 {\n    font-family: var(--font-sans);\n    line-height: var(--line-height-heading);\n    letter-spacing: -0.02em;\n    color: var(--text);\n}\n\n.tabular-nums {\n    font-variant-numeric: tabular-nums;\n}\n\n.font-mono,\ncode,\npre,\n.label-caps {\n    font-family: var(--font-mono);\n}\n\n/* ============================================================\n   TOASTIFY DESIGN SYSTEM INTEGRATION\n   ============================================================ */\n\n.Toastify__toast {\n    font-family: var(--font-sans) !important;\n    background-color: var(--surface) !important;\n    color: var(--text) !important;\n    border-radius: var(--radius-lg) !important;\n    border: 1px solid var(--border-subtle) !important;\n    box-shadow: var(--edge-highlight), 0 10px 25px -5px rgba(0, 0, 0, 0.25) !important;\n}\n.Toastify__toast--success {\n    border-color: var(--status-success) !important;\n}\n.Toastify__toast--error {\n    border-color: var(--status-danger) !important;\n}\n.Toastify__toast--warning {\n    border-color: var(--status-warning) !important;\n}\n.Toastify__progress-bar {\n    background: var(--accent) !important;\n}\n.Toastify__close-button {\n    color: var(--text-muted) !important;\n}\n\n/* Modern Minimal Scrollbar */\n::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n}\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n::-webkit-scrollbar-thumb {\n    background: var(--border);\n    border-radius: 9999px;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: var(--text-faint);\n}\n\n/* Disabled button state */\nbutton:disabled {\n    opacity: 0.45 !important;\n    cursor: not-allowed !important;\n}\n\n/* ============================================================\n   MICRO-ANIMATIONS & UTILITIES\n   ============================================================ */\n\n@keyframes stitch-shimmer {\n    0%   { background-position: -400px 0; }\n    100% { background-position: 400px 0; }\n}\n\n@keyframes stitch-fade-in {\n    from { opacity: 0; transform: translateY(4px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes stitch-slide-up {\n    from { opacity: 0; transform: translateY(12px) scale(0.99); }\n    to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes stitch-pulse-dot {\n    0%, 100% { opacity: 1; transform: scale(1); }\n    50%      { opacity: 0.4; transform: scale(0.9); }\n}\n\n.stitch-shimmer {\n    background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.06) 50%, transparent 100%);\n    background-size: 800px 100%;\n    animation: stitch-shimmer 1.5s ease-in-out infinite;\n}\n\n.stitch-fade-in {\n    animation: stitch-fade-in 0.25s ease-out both;\n}\n\n.stitch-slide-up {\n    animation: stitch-slide-up 0.25s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n\n.stitch-pulse-dot {\n    animation: stitch-pulse-dot 2s ease-in-out infinite;\n}\n\n/* ============================================================\n   MODERN HIGH-DENSITY DATA TABLE STYLES\n   ============================================================ */\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.875rem;\n}\n\nth {\n    padding: 10px 14px !important;\n    font-family: 'Hanken Grotesk', 'Inter', sans-serif !important;\n    font-size: 0.75rem !important;\n    font-weight: 700 !important;\n    text-transform: uppercase !important;\n    letter-spacing: 0.05em !important;\n    color: var(--color-subtext) !important;\n    background-color: var(--color-control, #F1F5F9) !important;\n    border-bottom: 1px solid var(--color-border) !important;\n    white-space: nowrap !important;\n    user-select: none;\n}\n\ntd {\n    padding: 12px 14px !important;\n    font-size: 0.875rem !important;\n    color: var(--color-text) !important;\n    border-bottom: 1px solid var(--color-border) !important;\n    transition: background-color 0.15s ease;\n}\n\ntbody tr:hover td {\n    background-color: var(--surface-2) !important;\n}\n\n/* ============================================================\n   MODERN FORM CONTROLS & FIELDSETS\n   ============================================================ */\n\n.form-control,\ninput[type=\"text\"]:not(.has-icon-left):not([class*=\"pl-\"]),\ninput[type=\"email\"]:not(.has-icon-left):not([class*=\"pl-\"]),\ninput[type=\"password\"]:not(.has-icon-left):not([class*=\"pl-\"]),\ninput[type=\"number\"]:not(.has-icon-left):not([class*=\"pl-\"]),\ninput[type=\"search\"]:not(.has-icon-left):not([class*=\"pl-\"]),\nselect,\ntextarea {\n    width: 100%;\n    height: 40px;\n    padding: 0 14px;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: var(--text);\n    background-color: var(--surface-2);\n    border: 1px solid var(--border-strong);\n    border-radius: var(--radius-md);\n    outline: none;\n    box-shadow: var(--edge-highlight);\n    transition: border-color 180ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 180ms cubic-bezier(0.4, 0, 0.2, 1), background-color 180ms ease;\n}\n\n.has-icon-left {\n    padding-left: 2.5rem !important; /* 40px clear margin for icons */\n}\n\ntextarea {\n    height: auto;\n    padding: 10px 14px;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus {\n    background-color: var(--surface) !important;\n    border-color: var(--border-active) !important;\n    box-shadow: 0 0 0 1px var(--border-active), 0 0 0 3px var(--accent-soft) !important;\n}\n\nfieldset {\n    border: 1px solid var(--border-subtle) !important;\n    border-radius: var(--radius-lg) !important;\n    padding: 16px 20px !important;\n    margin-bottom: 16px !important;\n    background-color: transparent !important;\n}\n\nlegend {\n    width: auto !important;\n    padding: 0 8px !important;\n    font-family: 'Hanken Grotesk', 'Inter', sans-serif !important;\n    font-size: 0.95rem !important;\n    font-weight: 700 !important;\n    color: var(--accent) !important;\n    margin-bottom: 0 !important;\n}\n\n/* ============================================================\n   CARD, BADGE & UI COMPONENT ENHANCEMENTS\n   ============================================================ */\n\n.card {\n    position: relative;\n    border-radius: var(--radius-lg) !important;\n    background-color: var(--surface) !important;\n    background-image: \n        linear-gradient(var(--surface), var(--surface)), \n        linear-gradient(135deg, var(--border-gradient-start) 0%, var(--border-gradient-end) 100%) !important;\n    background-origin: padding-box, border-box !important;\n    background-clip: padding-box, border-box !important;\n    border: 1px solid transparent !important;\n    box-shadow: var(--edge-highlight) !important;\n}\n\n.card-header {\n    background-color: transparent !important;\n    border-bottom: 1px solid var(--border-subtle) !important;\n    padding: 14px 18px !important;\n}\n\n/* NProgress minimal sleek bar */\n#nprogress .bar {\n    background: var(--accent) !important;\n    height: 2.5px !important;\n    z-index: 10319 !important;\n}\n#nprogress .spinner {\n    top: 16px !important;\n    right: 16px !important;\n    z-index: 10316 !important;\n}\n#nprogress .spinner-icon {\n    border-top-color: var(--accent) !important;\n    border-left-color: var(--accent) !important;\n}\n\n/* React Loading Skeleton */\n.react-loading-skeleton {\n    --base-color: var(--surface-2) !important;\n    --highlight-color: var(--border) !important;\n}\n\n.dark .react-loading-skeleton,\n[data-theme=\"dark\"] .react-loading-skeleton {\n    --base-color: var(--surface-2) !important;\n    --highlight-color: var(--border) !important;\n}\n\n/* Breadcrumb styling */\n.breadcrumb-item {\n    font-size: 0.85rem !important;\n    font-weight: 500 !important;\n    color: var(--text-muted) !important;\n}\n.breadcrumb-item.active {\n    color: var(--accent) !important;\n    font-weight: 600 !important;\n}\n\n/* ── Global Seamless & Nested Input Resets (Prevent Double Borders & Rings) ── */\ninput[type=\"text\"].bg-transparent,\ninput[type=\"email\"].bg-transparent,\ninput[type=\"password\"].bg-transparent,\ninput[type=\"number\"].bg-transparent,\ninput[type=\"search\"].bg-transparent,\ninput.input-seamless,\n.auth-input {\n    background-color: transparent !important;\n    border: none !important;\n    outline: none !important;\n    box-shadow: none !important;\n    -webkit-appearance: none;\n    padding: 0 !important;\n    height: 100% !important;\n    min-height: auto !important;\n    border-radius: 0 !important;\n}\n\n/* ── Dedicated High-Contrast Auth Input Style ── */\n.auth-input-field {\n    color: var(--text) !important;\n    background-color: transparent !important;\n    border: none !important;\n    outline: none !important;\n    box-shadow: none !important;\n    width: 100% !important;\n    font-size: 0.875rem !important;\n    font-weight: 600 !important;\n}\n\n.auth-input-field::placeholder {\n    color: var(--text-faint) !important;\n    opacity: 1 !important;\n    font-weight: 400 !important;\n}\n\ninput[type=\"text\"].bg-transparent:focus,\ninput[type=\"email\"].bg-transparent:focus,\ninput[type=\"password\"].bg-transparent:focus,\ninput[type=\"number\"].bg-transparent:focus,\ninput[type=\"search\"].bg-transparent:focus,\ninput.input-seamless:focus,\n.auth-input:focus,\n.search-wrapper input:focus {\n    outline: none !important;\n    box-shadow: none !important;\n    border: none !important;\n    background-color: transparent !important;\n}\n\n/* ── WebKit / Chrome Autofill Normalization ── */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover, \ninput:-webkit-autofill:focus, \ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 1000px var(--surface-2) inset !important;\n    -webkit-text-fill-color: var(--text) !important;\n    transition: background-color 5000s ease-in-out 0s;\n}\n\n/* ── Toast Notifications ── */\n.Toastify__toast {\n    background-color: var(--surface) !important;\n    color: var(--text) !important;\n    border: 1px solid var(--border) !important;\n    border-radius: 12px !important;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25) !important;\n}\n.Toastify__toast-body {\n    color: var(--text) !important;\n}\n.Toastify__close-button {\n    color: var(--text-muted) !important;\n}\n.Toastify__progress-bar--success { background: var(--success) !important; }\n.Toastify__progress-bar--warning { background: var(--warning) !important; }\n.Toastify__progress-bar--error   { background: var(--danger)  !important; }\n.Toastify__progress-bar--info    { background: var(--info)    !important; }\n\n/* ── Modal Animation Utilities ── */\n@keyframes stitchSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(12px) scale(0.985);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n@keyframes stitchFadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n.stitch-slide-up {\n    animation: stitchSlideUp 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n.stitch-fade-in {\n    animation: stitchFadeIn 0.18s ease-out forwards;\n}\n\n/* ============================================================\n   UNIVERSAL THEME SURFACES & KPI GRID (ROBUST DARK & LIGHT MODES)\n   ============================================================ */\n\n.card-surface,\n.bg-card-surface {\n    background-color: var(--surface) !important;\n    color: var(--text) !important;\n    border-color: var(--border) !important;\n}\n\n.card-surface-2,\n.bg-card-surface-2 {\n    background-color: var(--surface-2) !important;\n    color: var(--text) !important;\n    border-color: var(--border) !important;\n}\n\n/* Direct dark mode overrides for any hardcoded classes */\n.dark .card-surface,\n.dark .bg-white,\n[data-theme=\"dark\"] .card-surface,\n[data-theme=\"dark\"] .bg-white {\n    background-color: var(--surface) !important;\n    color: var(--text) !important;\n    border-color: var(--border) !important;\n}\n\n.dark .bg-slate-50,\n[data-theme=\"dark\"] .bg-slate-50,\n.dark .bg-slate-100,\n[data-theme=\"dark\"] .bg-slate-100 {\n    background-color: var(--surface-2) !important;\n    color: var(--text) !important;\n    border-color: var(--border) !important;\n}\n\n.dark text,\n[data-theme=\"dark\"] text {\n    fill: var(--text) !important;\n}\n\n/* Urgent / Alert Cards in Light and Dark Mode */\n.kpi-card-urgent {\n    background-color: #FFF1F2 !important;\n    border-color: #FECDD3 !important;\n}\n.dark .kpi-card-urgent,\n[data-theme=\"dark\"] .kpi-card-urgent {\n    background-color: rgba(225, 29, 72, 0.12) !important;\n    border-color: rgba(244, 63, 94, 0.3) !important;\n}\n\n.card-urgent-surface {\n    background-color: #FFF5F5 !important;\n    border-color: #FECDD3 !important;\n}\n.dark .card-urgent-surface,\n[data-theme=\"dark\"] .card-urgent-surface {\n    background-color: rgba(225, 29, 72, 0.08) !important;\n    border-color: rgba(244, 63, 94, 0.25) !important;\n}\n\n/* 6-Card KPI Horizontal Grid with Guaranteed Responsiveness */\n.kpi-cards-grid {\n    display: grid !important;\n    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;\n    gap: 0.875rem !important;\n    width: 100% !important;\n}\n\n@media (max-width: 1400px) {\n    .kpi-cards-grid {\n        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n    }\n}\n\n@media (max-width: 768px) {\n    .kpi-cards-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .kpi-cards-grid {\n        grid-template-columns: 1fr !important;\n    }\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
